import React, { useEffect, useState } from 'react'
import { Button, FormControlLabel, Switch } from '@mui/material'
import CustomModal from 'Shared/CustomModal'
import { useMutation, useQueryClient } from 'react-query'
import { UpdateSellerFn } from 'Services/Seller'
import { toast } from 'react-toastify'

const AdditionalDetail = ({ data }) => {
    const [open, setOpen] = useState(false)
    const [statuses, setStatuses] = useState({})
    const [updatingKey, setUpdatingKey] = useState(null)

    const client = useQueryClient()

    const toggleItems = [
        {
            key: "trusted_seller",
            label: "Trusted Seller",
            icon: "https://www.tradeindia.com/images/v2/t-seller.png",
        },
        {
            key: "super_seller",
            label: "Super Seller",
            icon: "https://www.tradeindia.com/images/v2/s-seller.png",
        },
        {
            key: "super_bonanza",
            label: "Super Bonanza",
            icon: "https://www.tradeindia.com/images/v2/s-bonanza.png",
        },
        {
            key: "super_premium",
            label: "Super Premium",
            icon: "https://www.tradeindia.com/images/v2/s-premium.png",
        },
        {
            key: "premium_seller",
            label: "Premium Seller",
            icon: "https://www.tradeindia.com/images/v2/premium-seller.png",
        },
    ]


    const { mutate } = useMutation(UpdateSellerFn, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {

                toast.success(res?.data?.message)

                client.refetchQueries("get-seller-list")



            }

            else {

                toast.warn(res?.data?.message)



            }



        }
    })

    useEffect(() => {
        if (data) {

            const init = {}
            toggleItems.forEach((key) => {
                init[key.key] = data[key.key] ?? false
            })
            setStatuses(init)
        }
    }, [data])

    const handleToggle = async (key) => {
        const newValue = !statuses[key]
        const updatedStatuses = { ...statuses, [key]: newValue }
        setStatuses(updatedStatuses)
        setUpdatingKey(key)



        mutate({ seller_id: data?.id, [key]: newValue })
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <Button variant="outlined" color="success" onClick={() => setOpen(true)}>
                Status
            </Button>

            <CustomModal
                open={open}
                title="Update Seller Status"
                onClose={handleClose}
                className="!w-[300px]"
                padding={3}


            >
                <div className=' grid'>
                    {toggleItems.map(({ key, label, icon }) => (
                        <div key={key} className="flex justify-between items-center py-2">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={statuses[key] || false}
                                        onChange={() => handleToggle(key)}
                                        color="primary"

                                    />
                                }
                                label={
                                    <span className="flex items-center gap-2">
                                        <img src={icon} alt="icon" className="w-4 h-4" />
                                        {label}
                                    </span>
                                }
                            />
                        </div>
                    ))}
                </div>
            </CustomModal>
        </>
    )
}

export default AdditionalDetail
